class SynaFaqHub {
  constructor(root) {
    this.root = root;
    this.search = root.querySelector('[data-faq-search]');
    this.filters = [...root.querySelectorAll('[data-faq-filter]')];
    this.items = [...root.querySelectorAll('[data-faq-item]')];
    this.status = root.querySelector('[data-faq-status]');
    this.empty = root.querySelector('[data-faq-empty]');
    this.category = 'all';
    this.query = '';
    this.bind();
    this.update();
  }

  bind() {
    this.filters.forEach((button) => {
      button.addEventListener('click', () => {
        this.category = button.dataset.faqFilter;
        this.filters.forEach((filter) => filter.setAttribute('aria-pressed', String(filter === button)));
        this.update();
      });
    });

    this.search?.addEventListener('input', () => {
      this.query = this.search.value.trim().toLowerCase();
      this.update();
    });

    this.root.querySelectorAll('[data-faq-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const answer = document.getElementById(button.getAttribute('aria-controls'));
        const opening = button.getAttribute('aria-expanded') !== 'true';
        this.root.querySelectorAll('[data-faq-toggle][aria-expanded="true"]').forEach((other) => {
          if (other === button) return;
          other.setAttribute('aria-expanded', 'false');
          const otherAnswer = document.getElementById(other.getAttribute('aria-controls'));
          if (otherAnswer) otherAnswer.hidden = true;
        });
        button.setAttribute('aria-expanded', String(opening));
        if (answer) answer.hidden = !opening;
      });
    });
  }

  update() {
    let visible = 0;
    this.items.forEach((item) => {
      const categoryMatch = this.category === 'all' || item.dataset.category === this.category;
      const queryMatch = !this.query || item.dataset.searchText.toLowerCase().includes(this.query);
      item.hidden = !(categoryMatch && queryMatch);
      if (!item.hidden) visible += 1;
    });
    if (this.empty) this.empty.hidden = visible !== 0;
    if (this.status) this.status.textContent = `${visible} ${visible === 1 ? 'question' : 'questions'} shown`;
  }
}

const initialiseCorePages = (root = document) => {
  root.querySelectorAll('[data-syna-faq-hub]:not([data-faq-ready])').forEach((hub) => {
    hub.dataset.faqReady = 'true';
    new SynaFaqHub(hub);
  });
};

initialiseCorePages();
document.addEventListener('shopify:section:load', (event) => initialiseCorePages(event.target));
